export default {
  name: 'purchase-management',
  translationKey: 'purchase-management-module',
  routePrefix: 'purchase-management',
  routeNamePrefix: 'admin.purchase-management',
  directRoutesAvailable: false,
}
